import { authStore, useAuthStore } from '@jq4race/api-client';

import type { MfaIntent, Session } from '../modules/auth/domain/entities/session';

export function getCurrentSession(): Session | null {
  return authStore.get();
}

export function getCurrentMfaIntent(): MfaIntent | null {
  return useAuthStore.getState().mfaIntent;
}
